module.exports = __webpack_public_path__ + "img/cave.be5030ca.webp";